define('Cubix_StockProduct/js/stockproduct',["jquery", "jplist", "jquery-ui-modules/autocomplete"], function ($) {
  "use strict";
  $.widget("cubix.stockproduct", {
    options: {
      attributesetname: "",
      api: "",
      postcodeapi: "",
      productcode: "",
      pdptype: "",
      currentproductcode: "",
      scroll: "",
    },
    _create: function () {
      this._EventListener();
    },
    _EventListener: function () {
      var $widget = this;

      $widget.loadProductList();

      // Hide dropdown when clicking outside of it
      $(document).on("click", function (event) {
        if (
          !$(event.target).closest(".jplist-dd-content").length &&
          !$(event.target).is(".jplist-dd-panel")
        ) {
          // Hide the dropdown if the click is outside the dropdown and not on the button
          $(".jplist-dd-content").hide();
        }
      });

      $(document).on("click", "#load-more-button", function () {
        var showing = $(".instocks-items:visible").length;
        $(".instocks-items")
          .slice(showing - 1, showing + 8)
          .show();
        var totalItemCount = $(".instocks-items").length;
        showing = $(".instocks-items:visible").length;

        // // Hide the "Load More" button when all items are displayed
        if (showing >= totalItemCount) {
          $("#load-more-button").hide();
        }
      });

      $(document).on("click", ".jplist-dd-panel:first", function () {
        $(".jplist-dd-content").show();
      });

      $(document).on("click", ".jplist-dd-item", function () {
        $(".jplist-dd-content").hide();
      });

      $(document).on("click", "#tab-similar-items", function () {
        $("#similar-items").show();
        $("#in-stock-tab-content").hide();
      });

      $(document).on("click", ".store_names", function () {
        $("#load-more-button").show();
        $(".instocks-items").hide();
        $(".instocks-items").slice(0, 8).show();

        var totalItemCount = $(".instocks-items").length;
        var showing = $(".instocks-items:visible").length;

        // // Hide the "Load More" button when all items are displayed
        if (showing >= totalItemCount) {
          $("#load-more-button").hide();
        }
      });

      $(document).on("click", "#tab-in-stock", function () {
        $("#similar-items").hide();
        $("#in-stock-tab-content").show();
      });

      $(document).on("click", ".select_stock_product", function (e) {
        $(this).html("Selected");
        var offset = $("#stock-product-preview").offset();
      });

      $(document).on("change", ".stock_ring_size", function () {
        var ring_size = $(this).val();
        $("#ring_size").val(ring_size);
        return false;
      });

      $(document).on("click", ".stock_product_tr .clickable", function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        var product_id = $(this).parent().attr("data-productid");
        var product_detail_selector = ".product-detail-" + product_id;
        if ($(this).parent().hasClass("active")) {
          $(product_detail_selector).slideToggle("slow");
        } else {
          $("#stockproducts-table .table-body").removeClass("active");
          $("#stockproducts-table .product-detail").slideUp("slow");
          $(this).parent().addClass("active");
          $(product_detail_selector).slideDown("slow");
          $widget.loadProduct();
        }
      });

      //Select first product by default
      if ($(".stock_product_tr .clickable:first").length) {
        $(".stock_product_tr .clickable:first").delay(2000).click();
      }

      $(document).on("click", ".instockaddtocart", function (e) {
        $(this).text("Adding...");
        var form = $(this).parents("form");
        var url = form.attr("action");
        $widget.addProductToCart(form);
      });

      $(document).on("keydown.autocomplete", "#postcode_search", function () {
        $widget.autoComplete(this);
      });

      $(document).on("click", "#similar_items_postcode_submit", function () {
        var postcode = $("#postcode_search").val();
        $(".postcode-error").text("");
        if (postcode != "") {
          /*Validate Postcode*/
          if ($widget.is_ukPostCode(postcode)) {
            $widget.loadProductList();
          } else {
            $(".postcode-error").text("Please enter valid postcode.");
          }
        }
      });
    },
    autoComplete: function (e) {
      var $widget = this;
      $(e).autocomplete({
        source: function (request, response) {
          $.ajax({
            url: $widget.options.postcodeapi,
            type: "post",
            dataType: "json",
            data: {
              p: request.term,
            },
            success: function (data) {
              response(data);
            },
            messages: {
              noResults: "no results",
              results: function (amount) {
                return amount + "results.";
              },
            },
          });
        },
      });
    },
    is_ukPostCode: function (postcode) {
      var regexp =
        /^[A-Z]{1,2}[0-9RCHNQ][0-9A-Z]?\s?[0-9][ABD-HJLNP-UW-Z]{2}$|^[A-Z]{2}-?[0-9]{4}$/;
      if (regexp.test(postcode)) {
        return true;
      } else {
        return false;
      }
    },
    loadProductList: function () {
      $("#dh_loading").show();
      var $widget = this;
      var api = $widget.options.api;
      var productcode = $widget.options.productcode;
      var currentproductcode = $widget.options.currentproductcode;
      var pdptype = $widget.options.pdptype;
      var postcode = $("#postcode_search").val();
      var paramData = {
        ajax: 1,
        postcode: postcode,
        productcode: productcode,
        pdptype: pdptype,
        currentproductcode: currentproductcode,
        r: Math.random() * 100000,
      };

      $.ajax({
        url: api,
        data: paramData,
        headers: { "cache-control": "no-cache" },
        type: "get",
        dataType: "json",
        cache: true,
        timeout: 10000,
      })
        .done(function (response) {
          if ($.trim(response["html"]) != "") {
            $(".in-stock-wrap:first")
              .replaceWith(response["html"])
              .trigger("contentUpdated");
            $(".in-stock-tab").show();
            // if ($widget.options.scroll == 1) {
            //   $("#pdp-instock-tab").click();
            //   $("html, body").scrollTop(jQuery("#in").offset().top);
            // }
          } else {
            $('#in-stock').hide();
            var msg = response.error_message;
          }

          // jplist.init();
          //get a jPList control element
          // if ($("#instock-pagination").length) {
          //   const instockelement =
          //     document.getElementById("instock-pagination");
          //   instockelement.addEventListener(
          //     "jplist.state",
          //     (e) => {
          //       if (e.jplistState.filtered.length <= 1) {
          //         $("#instock-pagination").hide();
          //       } else {
          //         $("#instock-pagination").show();
          //       }
          //     },
          //     false
          //   );
          // }

          var totalItemCount = $(".instocks-items").length;
          // Hide the "Load More" button when all items are displayed
          if (totalItemCount <= 8) {
            $("#load-more-button").hide();
          }

          $(".instocks-items").hide();
          $(".instocks-items").slice(0, 8).show();

          $("#dh_loading").hide();
        })
        .fail(function (error) {
          $("#dh_loading").hide();
        });
    },
    addProductToCart: function (form) {
      var url = form.attr("action");
      $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function (data) {
          parent.document.location.href = "/checkout/cart";
        },
      });
    },
  });
  return $.cubix.stockproduct;
});

